// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "#licenses{padding:3%}.attention .ant-card-head-title{color:red}", ""]);
// Exports
module.exports = exports;
